import { createSelector } from 'reselect'
import { getArrayOfObjectValues } from '../../utils';

export const getCustomersSelector = createSelector(
  customer => customer.customer,
  (customersById) => getArrayOfObjectValues(customersById)
);